import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SnigelService } from '@uc/web/core';
import { AsyncPipe } from '@angular/common';
import { map, Observable, Subscription, tap } from 'rxjs';
import { RecommendedUnisCarouselComponent } from '@uc/web/shared/feature/feature-recommended-universities';
import { StickyLeadBarRendererComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { LoadingAnimationService } from '@uc/shared/ui';
import { SeoMetadataService } from '@uc/utilities';
import {
	fetchFeaturedWithCategory,
	fetchSingleArticle,
} from '../../data-access/+state/advice.actions';
import {
	getStateAdviceFeatured,
	getStateAdviceSingleArticle,
} from '../../data-access/+state/advice.selectors';
import { AdviceService } from '../../services/advice.service';
import { ARTICLE_REDIRECTS } from '../../static/advice.properties';
import { ArticleContainerComponent } from '@uc/web/shared/feature/feature-article-container';

@Component({
	selector: 'uc-article',
	templateUrl: './article.component.html',
	imports: [
		AsyncPipe,
		ArticleContainerComponent,
		StickyLeadBarRendererComponent,
		RecommendedUnisCarouselComponent,
	],
})
export class ArticleComponent implements OnInit, OnDestroy {
	loadingArticle = true;
	loadingHtml!: string;
	categoryKey!: string; //e.g. Student_Advice
	articleCategory!: string; // student
	articleUrl!: string; //specific url for article e.g. 'two-year-degree'
	articleCategoryUrl!: string; // e.g /advice/student
	metaTitle!: string;
	metaDescription!: string;
	url!: string;
	article: any;
	featuredArticles$: Observable<any> = this._store.select(getStateAdviceFeatured);

	private _routerSub!: Subscription;

	article$: Observable<any> = this._store.select(getStateAdviceSingleArticle).pipe(
		map((article) => {
			if (article?.artid) {
				this.article = { ...article };
				this.article.content = this._snigelSrv.insertAdsIntoContent(
					this.article.content,
				);

				this._seoSrv.updateTitle(article?.seotitle);
				this._seoSrv.updateDescription(article?.seodesc);
				this.url = `https://universitycompare.com${this._router.url}`;

				//create twitter card
				const og = {
					title: article?.title,
					description: article?.seodesc,
					type: 'website',
					url: this.url,
					image: article?.imgname,
				};

				this._seoSrv.createOgTags('property', og, 'og');
				this._seoSrv.createOgTags('name', this._seoSrv.twitterConfig, 'twitter');

				this.loadingArticle = false;
			} else {
				this.loadingArticle = true;
			}

			return article;
		}),
		tap((data) => {
			if (!data) return;
			this.auctionAds();
		}),
	);

	constructor(
		private _store: Store,
		private _route: ActivatedRoute,
		private _router: Router,
		private _adviceSrv: AdviceService,
		private _seoSrv: SeoMetadataService,
		private _loadingSrv: LoadingAnimationService,
		private _snigelSrv: SnigelService,
	) {}

	ngOnInit(): void {
		this.loadingHtml = this._loadingSrv.createPara(2, 3);
		this._routerSub = this._route.params.subscribe((params) => {
			this.articleCategory = params['articleCategory'];

			this.articleUrl = params['articleUrl'];
			this.articleCategoryUrl = `/advice/${this.articleCategory}`;

			if (ARTICLE_REDIRECTS[this.articleUrl]) {
				const slug = ARTICLE_REDIRECTS[this.articleUrl];
				this._router.navigate(['/advice', this.articleCategory, slug]);
				return;
			}
			if (
				!this._adviceSrv.redirectFromIncorrectUrl(
					this.articleCategory,
					this.articleUrl,
				)
			)
				return;

			this.categoryKey = this._adviceSrv.getCategoryDetails(
				this.articleCategory,
			).key;

			const key = this.categoryKey.toLowerCase().split('_').join(' ');
			this._store.dispatch(fetchFeaturedWithCategory(key));
			this._store.dispatch(fetchSingleArticle(this.articleUrl, this.categoryKey));
		});
	}

	auctionAds() {
		this._snigelSrv.getAds([
			'incontent_1_dskt',
			'incontent_3_mob',
			'incontent_3_dskt',
			'incontent_5_dskt',
			'incontent_5_mob',
			'incontent_6_dskt',
			'incontent_6_mob',
		]);
	}

	ngOnDestroy(): void {
		this._routerSub?.unsubscribe();
	}
}
